// The adjustment formula for the print review preview: three 256-entry lookup
// tables (R, G, B). A copy of PoseAdjustments::ToneCurve (Ruby) and of the
// EC2 renderer's version -- read the formula and the reason for three copies
// there. poseAdjustmentToneCurve.test.js asserts this copy against the shared
// fixture, spec/fixtures/files/pose_adjustment_tone_curves.json.

// Breaks .5 rounding ties the same way in Ruby, JS and Python; see the Ruby copy.
const TIE_NUDGE = 1e-6;
// How far shadows / highlights at +-100 move their tone; see the Ruby copy.
const TONE_STRENGTH = 0.12;

const decode = (value) => (value <= 0.04045 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4);

const encode = (value) => (value <= 0.0031308 ? value * 12.92 : 1.055 * value ** (1 / 2.4) - 0.055);

const tone = (value, shadowAmount, highlightAmount) => (
  value
  + shadowAmount * 6.75 * value * (1 - value) ** 2
  + highlightAmount * 6.75 * value ** 2 * (1 - value)
);

const lookupTables = ({
  temperature = 0, tint = 0, exposure = 0, contrast = 0, highlights = 0, shadows = 0,
} = {}) => {
  const t = temperature / 100;
  const n = tint / 100;
  const exposureGain = 2 ** exposure;
  const slope = 1 + contrast / 100;
  const shadowAmount = (TONE_STRENGTH * shadows) / 100;
  const highlightAmount = (TONE_STRENGTH * highlights) / 100;
  const gains = [2 ** (0.35 * t + 0.10 * n), 2 ** (-0.20 * n), 2 ** (-0.35 * t + 0.10 * n)];

  return gains.map((gain) => {
    const table = new Uint8Array(256);
    for (let i = 0; i < 256; i += 1) {
      const linear = Math.min(decode(i / 255) * gain * exposureGain, 1);
      const y = (tone(encode(linear), shadowAmount, highlightAmount) - 0.5) * slope + 0.5;
      table[i] = Math.floor(Math.min(Math.max(y, 0), 1) * 255 + 0.5 + TIE_NUDGE);
    }
    return table;
  });
};

export default lookupTables;
